import { useId, useState, type FormEvent } from 'react';
import { Link } from 'react-router';

import { signIn } from '../data/authRepository.js';
import styles from './LoginPage.module.css';

/**
 * Native form, no form framework (skill 12). There is no "register" link on purpose:
 * public signup is disabled and accounts are created by the owner (decision B7).
 */
export function LoginPage() {
  const emailId = useId();
  const passwordId = useId();
  const errorId = useId();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setError(null);
    setIsSubmitting(true);

    const result = await signIn(email.trim(), password);
    if (!result.ok) {
      setError(result.error.message);
      setIsSubmitting(false);
    }
    // On success the session listener swaps the route; keep the button disabled.
  }

  return (
    <div className={styles.page}>
      <main className={styles.card}>
        <h1 className={styles.title}>
          {/* The heading is the logo; the alt text is what a screen reader announces. */}
          <img className={styles.logo} src="/brand/finos-logo.png" alt="Personal Finance OS" />
        </h1>
        <p className={styles.subtitle}>Đăng nhập để xem tài chính của bạn.</p>

        {error ? (
          <p className={styles.error} id={errorId} role="alert">
            <span aria-hidden="true">⚠️</span>
            {error}
          </p>
        ) : null}

        <form onSubmit={(event) => void handleSubmit(event)} noValidate>
          <div className={styles.field}>
            <label htmlFor={emailId}>Email</label>
            <input
              id={emailId}
              className={styles.input}
              type="email"
              name="email"
              autoComplete="username"
              inputMode="email"
              enterKeyHint="next"
              required
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              aria-describedby={error ? errorId : undefined}
            />
          </div>

          <div className={styles.field}>
            <label htmlFor={passwordId}>Mật khẩu</label>
            <input
              id={passwordId}
              className={styles.input}
              type="password"
              name="password"
              autoComplete="current-password"
              enterKeyHint="go"
              required
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              aria-describedby={error ? errorId : undefined}
            />
          </div>

          <button type="submit" className={styles.submit} disabled={isSubmitting}>
            {isSubmitting ? 'Đang đăng nhập…' : 'Đăng nhập'}
          </button>
        </form>

        <p className={styles.footer}>
          Dùng trên iPhone? <Link to="/cai-dat-ung-dung">Xem cách thêm vào màn hình chính</Link>
        </p>
      </main>
    </div>
  );
}
